var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5107 12.5537C24.6658 12.4132 24.7889 12.2462 24.8728 12.0624C24.9568 11.8786 25 11.6816 25 11.4826C25 11.2836 24.9568 11.0865 24.8728 10.9028C24.7889 10.719 24.6658 10.552 24.5107 10.4115L13.4394 0.353943C13.3162 0.241745 13.1698 0.152731 13.0086 0.0919965C12.8474 0.0312622 12.6747 1.46978e-07 12.5002 1.49059e-07C12.3257 1.5114e-07 12.1529 0.0312622 11.9917 0.0919965C11.8306 0.152731 11.6842 0.241745 11.5609 0.353943L0.489617 10.4115C-0.163204 11.0045 -0.163204 11.9606 0.489617 12.5537C1.14244 13.1467 2.19494 13.1467 2.84776 12.5537L12.5068 3.79117L22.1659 12.5658C22.8054 13.1467 23.8712 13.1467 24.5107 12.5537Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.0f9c9a436b5ed01926b2647f817240a6.svg";
export { ForwardRef as ReactComponent };